<template>
    <div id="sidebar" class="sidebar">
        <div data-scrollbar="true" data-height="100%">
            <div v-if="auth.scopes">
                <ul class="nav">
                    <li class="nav-header">Navigation</li>
                    <router-link to="/" tag="li">
                        <a>
                            <i class="fa fa-tachometer"></i>
                            <span>Dashboard</span>
                        </a>
                    </router-link>

                    <usman-nav
                        v-if="auth.scopes.includes('admin_userman')"
                    ></usman-nav>

                    <tryout-members
                        v-if="
                            auth.scopes.includes('admin_itembank') ||
                            auth.scopes.includes('admin_operational') ||
                            auth.scopes.includes('admin_userman') ||
                            auth.scopes.includes('read_tryout') ||
                            auth.scopes.includes('write_tryout')
                        "
                    ></tryout-members>

                    <oss-configs-nav
                        v-if="
                            auth.scopes.includes('admin_itembank') ||
                            auth.scopes.includes('admin_operational')
                        "
                    ></oss-configs-nav>

                    <tryoutgroup-nav
                        v-if="auth.scopes.includes('admin_itembank')"
                    ></tryoutgroup-nav>

                    <tryout-nav
                        v-if="
                            auth.scopes.includes('admin_itembank') ||
                            auth.scopes.includes('read_tryout')
                        "
                    ></tryout-nav>

                    <serial-nav
                        v-if="auth.scopes.includes('admin_itembank')"
                    ></serial-nav>

                    <liveclass-nav
                        v-if="auth.scopes.includes('admin_operational')"
                    ></liveclass-nav>

                    <modul-belajar
                        v-if="
                            auth.scopes.includes('admin_itembank') ||
                            auth.scopes.includes('admin_operational')
                        "
                    ></modul-belajar>

                    <itembank-nav
                        v-if="auth.scopes.includes('admin_itembank')"
                    ></itembank-nav>

                    <kodifikasi-nav
                        v-if="auth.scopes.includes('admin_itembank')"
                    ></kodifikasi-nav>

                    <modulpembelajaran-nav
                        v-if="auth.scopes.includes('admin_modul_belajar')"
                    ></modulpembelajaran-nav>

                    <pembayaran-nav
                        v-if="auth.scopes.includes('admin_sales')"
                    ></pembayaran-nav>

                    <video-nav
                        v-if="auth.scopes.includes('admin_itembank')"
                    ></video-nav>
                    <li>
                        <a
                            href="javascript:;"
                            class="sidebar-minify-btn"
                            data-click="sidebar-minify"
                        >
                            <i class="fa fa-angle-double-left"></i>
                        </a>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from "vuex";
import BimbelNav from "@/modules/bimbel_online/components/Navigation";
import DuelNav from "@/modules/duel/components/Navigation";
import ItembankNav from "@/modules/itembank/components/Navigation";
import KodifikasiNav from "@/modules/kodifikasi/components/Navigation";
import LiveClassNav from "@/modules/live_class/components/Navigation";
import OssConfigs from "@/modules/oss_configs/components/Navigation";
import PembayaranNav from "@/modules/pembayaran/components/Navigation";
import SerialNav from "@/modules/serial/components/Navigation";
import TryoutGroupNav from "@/modules/tryout_group/components/Navigation";
import TryoutMembers from "@/modules/tryout_members/components/Navigation";
import TryoutNav from "@/modules/tryout/components/Navigation";
import UserManagementNav from "@/modules/usman/components/Navigation";
import VideoNav from "@/modules/vd_pembelajaran/components/Navigation";

export default {
    name: "sidebar",

    components: {
        "bimbel-nav": BimbelNav,
        "duel-nav": DuelNav,
        "itembank-nav": ItembankNav,
        "kodifikasi-nav": KodifikasiNav,
        "liveclass-nav": LiveClassNav,
        "oss-configs-nav": OssConfigs,
        "pembayaran-nav": PembayaranNav,
        "serial-nav": SerialNav,
        "tryoutgroup-nav": TryoutGroupNav,
        "tryout-nav": TryoutNav,
        "usman-nav": UserManagementNav,
        "video-nav": VideoNav,
        TryoutMembers,
    },

    data: function () {
        return {
            scopes: [],
        };
    },

    mounted: function () {
        App.init();
    },

    computed: {
        ...mapState(["auth"]),
    },
};
</script>



// WEBPACK FOOTER //
// Sidebar.vue?0de2fb59